
  <template>
  <div v-if="hasAccessToPage">
    <v-container fluid>
      <v-row justify="start" class="mx-4">
        <v-col cols="12" sm="12" md="12" xl="11">
          <TestTypeTable @itemClicked="itemClicked">
            <template v-slot:headerTableRight>
              <v-btn color="white" class="black--text" @click="showCreateModal()"> <v-icon left>mdi-plus</v-icon> Create new Test Type </v-btn>
            </template>
          </TestTypeTable>
        </v-col>
      </v-row>
    </v-container>

    <!-- modal to create and edit test types -->
    <TestTypeModal
      v-if="showTestTypeModal"
      :showTestTypeModal="showTestTypeModal"
      :clickedItem="clickedTableItem"
      :modalType="modalType"
      :type="modalType"
    />

    <!-- modal to delete test types -->
    <TestTypeDeleteModal v-if="showDeleteTestTypeModal" :showDeleteTestTypeModal="showDeleteTestTypeModal" :clickedItem="clickedTableItem" />
  </div>
  <NoAccessMessage v-else />
</template>


<script>
import SharedFunctions from '@/mixins/SharedFunctions.vue';
import TestTypeTable from '@/views/TestTypes/components/test-type-table.vue';
import TestTypeModal from '@/views/TestTypes/components/test-type-modal.vue';
import TestTypeDeleteModal from '@/views/TestTypes/components/delete-test-type-modal.vue';
import NoAccessMessage from '@/components/generic/no-access-message.vue';

export default {
  mixins: [SharedFunctions],
  components: {
    TestTypeTable,
    TestTypeModal,
    TestTypeDeleteModal,
    NoAccessMessage
  },
  data() {
    return {
      hasAccessToPage: null,
      showTestTypeModal: false,
      showDeleteTestTypeModal: false,
      clickedTableItem: null,
      modalType: null
    };
  },
  created() {
    this.hasAccessToPage = this.hasAccessToPageMixin();
  },
  methods: {
    itemClicked(value) {
      this.showTestTypeModal = true;
      this.clickedTableItem = value;
      this.modalType = 'edit';
    },
    showCreateModal() {
      this.modalType = 'new';
      this.showTestTypeModal = true;
    }
  }
};
</script>

<style lang="scss">
.test-type-table-component {
  tr.row-class {
    &:hover {
      background: whitesmoke !important;
      cursor: pointer;
    }
  }
}
</style>